import React from 'react';
import './KeyAreas.css';

const KeyAreas = () => {
  return (
    <div className="key-areas-section">
      <h2 className="key-areas-title">
      You’ll be scored against 2 key areas to determine your restaurant’s online performance:
      </h2>
      
      <div className="key-areas-cards">
        <div className="key-area-card">
          <div className="key-area-icon">
            <img src="/thumbsup.svg" alt="Customer Engagement icon for restaurant online ordering assessment" className="engagement-icon" />
          </div>
          <h3 className="key-area-card-title">Customer Engagement</h3>
          <p className="key-area-card-description">
          Customer engagement is a key factor in growing your restaurant online. Strong engagement means more people discovering your menu, interacting with your brand and placing orders more often. Both online and in person.
          </p>
        </div>

        <div className="key-area-card">
          <div className="key-area-icon">
            <img src="/influence.svg" alt="Ordering Efficiency icon for restaurant online ordering assessment" className="influence-icon" />
          </div>
          <h3 className="key-area-card-title">Ordering Efficiency</h3>
          <p className="key-area-card-description">
          Understanding how well your current ordering setup works for your customers is essential. Efficient systems make it easy for guests to order, pay and return again. Boosting repeat business and overall sales.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KeyAreas;
